<template>
  <v-sheet class="mx-auto" max-width="2000">
    <ProfileForm sub-title="Manage your basic information"
                 cv-sub-title="You may also upload your curriculum vitae"
                 :display-cv="hasAccessRight('virtual-panel')"
                 v-on:closed="closeProfile()">
    </ProfileForm>
  </v-sheet>
</template>

<script>
import {defineComponent} from 'vue';
import ProfileForm from '@/components/ProfileForm.vue';

export default defineComponent({
  name: 'ProfilePage',
  components: {
    ProfileForm
  },
  methods: {
    closeProfile() {
      this.$nextTick(() => {
        this.$router.back()
      })
    },
    hasAccessRight(accessRight) {
      return this.$store.getters.stateUser?.access_rights?.includes(accessRight);
    }
  }
});
</script>
